import { render, staticRenderFns } from "./SideNavclient.vue?vue&type=template&id=792db7a2"
import script from "./SideNavclient.vue?vue&type=script&lang=js"
export * from "./SideNavclient.vue?vue&type=script&lang=js"
import style0 from "./SideNavclient.vue?vue&type=style&index=0&id=792db7a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports